const ADMIN_TENANT_KEY = 'admin_tenant_code';
const ADMIN_API_PREFIXES = ['/admin/api/', '/admin-ap/api/', '/admin-us/api/'];

export type AdminTenant = {
  id: number;
  code: string;
  name: string;
  database_name: string;
  selected?: boolean;
};

export function getAdminTenant(): string | null {
  return localStorage.getItem(ADMIN_TENANT_KEY);
}

export function setAdminTenant(code: string): void {
  localStorage.setItem(ADMIN_TENANT_KEY, code);
}

export function removeAdminTenant(): void {
  localStorage.removeItem(ADMIN_TENANT_KEY);
}

let fetchInterceptorInstalled = false;

export function installAdminTenantFetchInterceptor(): void {
  if (fetchInterceptorInstalled || typeof window === 'undefined') return;
  fetchInterceptorInstalled = true;

  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const requestUrl =
      typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.href
          : input.url;
    const url = new URL(requestUrl, window.location.href);
    if (!ADMIN_API_PREFIXES.some((prefix) => url.pathname.startsWith(prefix))) {
      return nativeFetch(input, init);
    }

    const tenant = getAdminTenant();
    if (!tenant) return nativeFetch(input, init);

    const headers = new Headers(
      input instanceof Request ? input.headers : undefined,
    );
    new Headers(init?.headers).forEach((value, key) => {
      headers.set(key, value);
    });
    headers.set('X-Admin-Tenant', tenant);

    return nativeFetch(input, { ...init, headers });
  };
}
